export default "__VITE_ASSET__D0ktc6Rm__"